import { useParams } from 'react-router-dom'
import EditUserForm from './EditUserForm'
import { useGetUsersQuery } from './usersApiSlice'
import {Spinner} from 'react-bootstrap'
import useTitle from '../../hooks/useTitle'

const EditUser = () => {
    useTitle('Nirakar Satguru: Edit User')

    const { id } = useParams()

    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[id]
        }),
    })

    if (!user) return <Spinner  />

    const content = <EditUserForm user={user} />

    return content
}
export default EditUser